import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9d6nx4c74q: FaireBrandEntity = {
  token: "b_9d6nx4c74q",
  type: "brand",
  name: "Ceriello Fine Foods",
  avatarUrl:
    "https://cdn.faire.com/fastly/69c8e980b49921b1c66287d0eefe15bb7848f6bee36a3c23d88d6b2074a99994.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2fb0eef14a27988ff8b0da908722e51cb825ecdcfe1d96454a57a00e9a7eac03.png",
  logoUrl:
    "https://cdn.faire.com/fastly/69c8e980b49921b1c66287d0eefe15bb7848f6bee36a3c23d88d6b2074a99994.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2fb0eef14a27988ff8b0da908722e51cb825ecdcfe1d96454a57a00e9a7eac03.png",
  location: "Williston Park, NY, USA",
  minimumOrderDollars: 35,
  rating: 4.4,
  reviewCount: 7,
  isInsider: true,
  description:
    "In 1973, Andrea Ceriello started in the Italian food business. After establishing stores at various location in Staten Island and Long Island, he settled at our current location in 1980. \n\nIn its first days, he followed the traditions of the Italian Salumerie—known in New York as Pork Stores. No poultry was sold—and no spaghetti either! But over the years, the business has evolved into the one you now recognize as Ceriello Fine Foods. \n\nWe look forward to being part of your family’s meals and celebrations. After all, we are a family, too.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:10.385Z",
    importedBy: "entity-db-cli",
  },
};
